/**
 * Type for network offers, displayed on homepage (/)
 * @dev It contains offers accross all networks
 */
export type ActiveOffer = {
  /**
   * Main token address.
   * If tokenAddress is an LVT, main will be the unlocked token, otherwise main === tokenAddress
   */
  main: string
  tokenAddress: string
  tokenName: string
  tokenSymbol: string
  offers: number
  chainId: number
  network: string
  redirectUrl: string
}

/**
 * Type for token offers, displayed on /tokens/:tokenAddress table section
 * @dev No need to specify chainId or network, since all correspond to the same network from url query param
 */
export type ActiveTokenOffer = {
  /**
   * Order._id to redirect into the trade offer page
   * */
  _id: string

  symbol: string

  sellToken: string
  /** sellAmount formatted with decimals */
  sellAmount: number
  sellTokenSymbol: string

  buyToken: string
  /** buyAmount formatted with decimals */
  buyAmount: number
  buyTokenSymbol: string

  /**
   * Price per token
   */
  price: number
  /**
   * Price per token symbol.
   */
  priceSymbol: string
  /**
   * Price per token expressed in US$
   */
  priceUSD: number
  /**
   * Whether to hide the priceUSD
   * Used when the priceSymbol is an stablecoin
   */
  hideUSD: boolean

  /**
   * Date in milliseconds in which the offer will expire
   */
  expiry: number
}

export enum TokenOfferType {
  Buy = 'Buy',
  Sell = 'Sell',
  User = 'User',
}

/**
 * Type for token offers, used on /tokens/:tokenAddress for creating the ActiveTokenOffer array
 */
export type DetailedOrder = {
  _id: string
  maker: string
  buyToken: {
    address: string
    name: string
    symbol: string
    decimals: number
  }
  buyTokenParent?: string
  buyAmount: number
  sellToken: {
    address: string
    name: string
    symbol: string
    decimals: number
  }
  sellTokenParent?: string
  sellAmount: number
  expiry: number
}
